(()=>{
const root=window.Shopify?.routes?.root||'/';
const header=document.querySelector('.n-header');
if(header){
  let condensed=header.dataset.condensed==='true';
  let headerFrame=0;
  const updateHeader=()=>{
    headerFrame=0;
    const next=condensed?scrollY>32:scrollY>80;
    if(next===condensed)return;
    condensed=next;
    header.dataset.condensed=String(condensed);
  };
  const scheduleHeader=()=>{
    if(!headerFrame)headerFrame=requestAnimationFrame(updateHeader);
  };
  addEventListener('scroll',scheduleHeader,{passive:true});
  addEventListener('pageshow',scheduleHeader);
  updateHeader();
}
const colors={'hot pink':'#cf0060','white & mint':'linear-gradient(90deg,#f7f4ee 50%,#b4c9c2 50%)','almond white':'#eee8dc','brown':'#5b4739','dark slate green':'#43534f','peach':'#efc2a9','ivory':'#f2efe6','blush pink':'#d9aaa9','sand':'#c3ae90','olive':'#747c4f','teal':'#247876','deep teal':'#20534f','chartreuse':'#b3af51','pink':'#d9a3b5','lavender':'#aaa2bc','silver':'#c5c7cc','silver grey':'#b5b8ba','sage':'#a5b28f','plum':'#734063','rosewood':'#925861','violet':'#795589','rose':'#bb7979','rust':'#ae6346','mint':'#a8c2ac','fuchsia':'#b33c70','coral':'#df7f7b','emerald':'#276653','clay':'#b58870','mustard':'#b89744','purple':'#705c89','white and red':'linear-gradient(90deg,#f6f1e8 50%,#a93336 50%)','black':'#252324'};
Object.assign(colors,{'mustard & black':'linear-gradient(135deg,#d5a715 50%,#202020 50%)','teal & almond white':'linear-gradient(135deg,#247876 50%,#eee8dc 50%)','sky blue':'#a9cfdf','champagne':'#d9c6a5','sage green':'#a5b28f','lilac':'#bba7ca','orange':'#df8b48','red':'#b3373c','gold':'#b89b56','navy':'#233449','blue':'#5e9cac','green':'#497759'});
Object.assign(colors,{'white & red':'linear-gradient(135deg,#f6f1e8 50%,#a93336 50%)','white':'#f6f1e8','off white':'#f2efe6','yellow':'#d5b343'});
const paintSwatch=element=>{
  const name=element.dataset.color.toLowerCase().trim().replace(/\s+and\s+/g,' & ').replace(/\s*&\s*/g,' & ').replace(/\s+/g,' ');
  let fill=colors[name];
  if(!fill&&name.includes(' & ')) {
    const parts=name.split(' & ').map(part=>colors[part]);
    if(parts.length===2&&parts.every(part=>part&&part.startsWith('#'))) fill=`linear-gradient(135deg,${parts[0]} 50%,${parts[1]} 50%)`;
  }
  if(!fill&&CSS.supports('color',name)) fill=name;
  if(!fill) {
    const product=element.closest('[data-product]');
    const field=element.closest('[data-option-position]');
    if(product&&field) {
      try {
        const variants=JSON.parse(product.querySelector('[data-variants]').textContent);
        const variant=variants.find(item=>item['option'+field.dataset.optionPosition]?.toLowerCase()===element.dataset.color.toLowerCase()&&item.featured_image?.src);
        if(variant) { const image=new URL(variant.featured_image.src,location.origin); image.searchParams.set('width','96'); fill=`url("${image.href}") center / cover`; }
      } catch(error) { /* Keep the labelled neutral swatch when no matching photo exists. */ }
    }
  }
  element.style.background=fill||'repeating-conic-gradient(#f4f1ed 0% 25%,#d6d1cc 0% 50%) 0 0 / 8px 8px';
};
document.querySelectorAll('[data-color]').forEach(paintSwatch);
let menuCloseTimer;
const menuTriggers=[...document.querySelectorAll('a[data-menu-trigger],button[data-menu-trigger]')];
const toggleMenus=name=>{
  clearTimeout(menuCloseTimer);
  document.querySelectorAll('[data-menu-panel]').forEach(e=>{e.dataset.open=String(e.dataset.menuPanel===name);e.id='menu-'+e.dataset.menuPanel;});
  menuTriggers.forEach(e=>{e.setAttribute('aria-expanded',String(e.dataset.menuTrigger===name));e.setAttribute('aria-controls','menu-'+e.dataset.menuTrigger);});
};
menuTriggers.forEach(e=>{
  e.parentElement.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)toggleMenus(e.dataset.menuTrigger);});
  e.addEventListener('focusin',()=>{if(e.tagName==='A')toggleMenus(e.dataset.menuTrigger);});
  e.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();toggleMenus(e.dataset.menuTrigger);document.querySelector('[data-menu-panel="'+e.dataset.menuTrigger+'"] a')?.focus();}});
});
const shell=header?.parentElement;
shell?.addEventListener('mouseenter',()=>clearTimeout(menuCloseTimer));
shell?.addEventListener('mouseleave',()=>{menuCloseTimer=setTimeout(()=>toggleMenus(''),180);});
shell?.addEventListener('focusout',()=>{setTimeout(()=>{if(!shell.contains(document.activeElement))toggleMenus('');},0);});
document.addEventListener('click',e=>{if(!shell?.contains(e.target))toggleMenus('');});
document.addEventListener('keydown',e=>{if(e.key==='Escape'){
  const activePanel=e.target.closest('[data-menu-panel]');
  if(activePanel)menuTriggers.find(t=>t.dataset.menuTrigger===activePanel.dataset.menuPanel)?.focus();
  toggleMenus('');
  document.querySelector('[data-mobile-menu]')?.setAttribute('data-open','false');
  document.querySelector('[data-action="toggleMobile"]')?.setAttribute('aria-expanded','false');
}});
toggleMenus('');
document.addEventListener('click',e=>{
const b=e.target.closest('[data-action]');if(!b)return;const a=b.dataset.action;
if(a==='toggleMobile'){const p=document.querySelector('[data-mobile-menu]');p.dataset.open=String(p.dataset.open!=='true');b.setAttribute('aria-expanded',p.dataset.open)}
if(a==='toggleHouse'){const p=document.querySelector('[data-menu-panel="house"]');toggleMenus(e.detail===0&&p.dataset.open==='true'?'':'house');}
if(a.startsWith('mobToggle')){const p=b.nextElementSibling;p.dataset.open=String(p.dataset.open!=='true');b.setAttribute('aria-expanded',p.dataset.open)}
if(a.startsWith('faqToggle')||a==='chartToggle'){
  const p=b.nextElementSibling;if(!p)return;
  const open=p.dataset.open!=='true';
  if(open&&a.startsWith('faqToggle')){
    const group=b.closest('.n-accordion');
    group?.querySelectorAll('[data-action^="faqToggle"]').forEach(other=>{
      if(other===b)return;
      if(other.nextElementSibling)other.nextElementSibling.dataset.open='false';
      other.setAttribute('aria-expanded','false');
      if(other.lastElementChild)other.lastElementChild.textContent='+';
    });
  }
  p.dataset.open=String(open);b.setAttribute('aria-expanded',String(open));
  const marker=b.lastElementChild;if(marker)marker.textContent=open?'−':'+';
}
if(a.startsWith('heroGo'))showSlide(Number(a.slice(-1)),true);
if(/tst|testimonial/i.test(a)){const track=document.querySelector('.tst-track');if(track)track.scrollBy({left:(/prev/i.test(a)?-1:1)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
});
const hero=document.querySelector('section[aria-label="Hero"]');
const heroSlides=hero?[...hero.querySelectorAll('.proto-home-hero__slide')]:[];
const heroMedia=hero?[...hero.querySelectorAll(':scope > picture, :scope > img')]:[];
const heroMotion=matchMedia('(prefers-reduced-motion: reduce)');
const heroToggle=hero?.querySelector('[data-hero-toggle]');
let heroPointer=null,heroDragging=false,heroSuppressClick=false;
let slide=0,timer,heroHovered=false,heroFocused=false,heroPaused=heroMotion.matches;

let heroTrack=null,heroPhysical=1,heroSettling=false;
function positionHeroTrack(offset=0){if(heroTrack)heroTrack.style.transform='translate3d(calc('+(-heroPhysical*100)+'% + '+offset+'px),0,0)';}
function settleHeroTrack(){
 if(!heroTrack)return;
 heroTrack.style.transition='none';heroPhysical=slide+1;positionHeroTrack();
 void heroTrack.offsetWidth;heroTrack.style.removeProperty('transition');heroSettling=false;
}
if(hero&&heroSlides.length===heroMedia.length){
 const originalOverlay=hero.querySelector('.proto-home-hero__overlay');
 heroTrack=document.createElement('div');heroTrack.className='proto-home-hero__track';
 const panels=heroSlides.map((copy,i)=>{
  const panel=document.createElement('div');panel.className='proto-home-hero__panel';
  const overlay=document.createElement('div');overlay.className='proto-home-hero__overlay';
  const inner=document.createElement('div');inner.className='proto-home-hero__inner';
  const copyBox=document.createElement('div');copyBox.className='proto-home-hero__copy';
  copyBox.append(copy);inner.append(copyBox);overlay.append(inner);panel.append(heroMedia[i],overlay);
  copy.style.opacity='1';copy.style.transition='none';heroMedia[i].style.opacity='1';heroMedia[i].style.transition='none';
  heroMedia[i].querySelectorAll('img').forEach(image=>image.loading='eager');
  return panel;
 });
 const clonePanel=panel=>{const clone=panel.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.inert=true;clone.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));return clone;};
 heroTrack.append(clonePanel(panels[panels.length-1]),...panels,clonePanel(panels[0]));
 originalOverlay.remove();hero.prepend(heroTrack);positionHeroTrack();
 heroTrack.addEventListener('transitionend',event=>{if(event.target===heroTrack&&event.propertyName==='transform')settleHeroTrack();});
}

function scheduleHero(){
  clearTimeout(timer);
  const playing=!heroPaused&&!heroFocused&&!heroPointer&&!document.hidden;
  if(hero)hero.dataset.autoplay=playing?'playing':'paused';
  if(heroToggle){
    heroToggle.setAttribute('aria-label',heroPaused?heroToggle.dataset.playLabel:heroToggle.dataset.pauseLabel);
    const pauseIcon=heroToggle.querySelector('[data-hero-pause]'),playIcon=heroToggle.querySelector('[data-hero-play]');
    if(pauseIcon&&playIcon){pauseIcon.toggleAttribute("hidden",heroPaused);playIcon.toggleAttribute("hidden",!heroPaused);}
    else if(heroToggle.querySelector('span'))heroToggle.querySelector('span').textContent=heroPaused?'▶':'Ⅱ';
  }
  if(hero&&heroSlides.length>1&&playing)timer=setTimeout(()=>{showSlide(slide+1);scheduleHero()},4000);
}
function showSlide(index,manual=false){
  if(!hero||!heroSlides.length)return;
  const previous=slide;
  slide=(index+heroSlides.length)%heroSlides.length;
  if(heroTrack){
    heroPhysical=slide+1;
    if(previous===heroSlides.length-1&&index===heroSlides.length)heroPhysical=heroSlides.length+1;
    else if(previous===0&&index===-1)heroPhysical=0;
    positionHeroTrack();heroSettling=true;
    if(heroMotion.matches)settleHeroTrack();
  }
  heroSlides.forEach((content,i)=>{
    const active=i===slide;
    hero.style.setProperty('--slide'+i+'-op',heroTrack?'1':active?'1':'0');
    if(heroTrack)content.closest('.proto-home-hero__panel').inert=!active;
    hero.style.setProperty('--slide'+i+'-pe',active?'auto':'none');
    hero.style.setProperty('--dot'+i,active?'#fff':'rgba(255,255,255,.4)');
    hero.querySelector('[data-action="heroGo'+i+'"]')?.setAttribute('aria-pressed',String(active));
    content.setAttribute('aria-hidden',String(!active));
    content.querySelectorAll('a,button').forEach(link=>link.tabIndex=active?0:-1);
    heroMedia[i]?.setAttribute('aria-hidden',String(!active));
  });
  if(manual)scheduleHero();
}
if(hero){

  hero.addEventListener('pointerdown',event=>{
    if(!event.isPrimary||event.button!==0||event.target.closest('a,button,input,select,textarea'))return;
    if(heroSettling)settleHeroTrack();
    heroPointer={id:event.pointerId,x:event.clientX,y:event.clientY,time:performance.now()};
    heroDragging=false;
    scheduleHero();
  });
  hero.addEventListener('pointermove',event=>{
    if(!heroPointer||event.pointerId!==heroPointer.id)return;
    const dx=event.clientX-heroPointer.x,dy=event.clientY-heroPointer.y;
    if(!heroDragging&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>10){heroPointer=null;scheduleHero();return;}
    if(!heroDragging&&Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)){
      heroDragging=true;hero.classList.add('is-dragging');hero.setPointerCapture(event.pointerId);
    }
    if(heroDragging){positionHeroTrack(Math.max(-hero.clientWidth,Math.min(hero.clientWidth,dx)));event.preventDefault();}
  });
  function finishHeroDrag(event,cancelled=false){
    if(!heroPointer||event.pointerId!==heroPointer.id)return;
    const dx=event.clientX-heroPointer.x;
    const dragged=heroDragging;
    const elapsed=performance.now()-heroPointer.time;
    if(heroTrack)void heroTrack.offsetWidth;
    heroPointer=null;heroDragging=false;
    hero.classList.remove('is-dragging');hero.style.removeProperty('--hero-drag-x');
    if(hero.hasPointerCapture(event.pointerId))hero.releasePointerCapture(event.pointerId);
    if(dragged){heroSuppressClick=true;setTimeout(()=>{heroSuppressClick=false},400);}
    if(dragged&&!cancelled&&(Math.abs(dx)>Math.max(40,Math.min(110,hero.clientWidth*.16))||(Math.abs(dx)>25&&Math.abs(dx)/elapsed>.45)))showSlide(slide+(dx<0?1:-1),true);
    else {positionHeroTrack();heroSettling=true;}
    scheduleHero();
  }
  hero.addEventListener('pointerup',event=>finishHeroDrag(event));
  hero.addEventListener('pointercancel',event=>finishHeroDrag(event,true));
  hero.addEventListener('lostpointercapture',event=>finishHeroDrag(event,true));
  hero.addEventListener('click',event=>{if(heroSuppressClick){event.preventDefault();event.stopImmediatePropagation()}},true);
  hero.addEventListener('dragstart',event=>event.preventDefault());
  hero.addEventListener('keydown',event=>{
    if(event.target.closest('a,button,input,select,textarea'))return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showSlide(slide+(event.key==='ArrowRight'?1:-1),true);}
  });

  showSlide(0);


  hero.addEventListener('focusin',event=>{heroFocused=event.target.matches(':focus-visible');scheduleHero()});
  hero.addEventListener('focusout',()=>{setTimeout(()=>{heroFocused=hero.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');scheduleHero()},0)});
  hero.addEventListener('click',event=>{if(event.detail>0){heroFocused=false;scheduleHero()}});
  heroToggle?.addEventListener('click',()=>{heroPaused=!heroPaused;if(!heroPaused){heroHovered=false;heroFocused=false}scheduleHero()});
  document.addEventListener('visibilitychange',scheduleHero);
  heroMotion.addEventListener('change',event=>{heroPaused=event.matches;scheduleHero()});
  scheduleHero();
}
const key='naghmana-saved-v1';const read=()=>{try{const v=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(v)?v.filter(x=>x&&typeof x.handle==='string'&&typeof x.title==='string').slice(0,100).map(x=>({...x,title:x.title.replace(/\s*\u2014\s*/g,': ')})):[]}catch{return[]}};
function refreshSaved() {
  const items = read();
  document.querySelectorAll('[data-save]').forEach(button => button.setAttribute('aria-pressed', String(items.some(item => item.handle === button.dataset.handle))));
  const grid = document.querySelector('[data-saved-grid]');
  if (!grid) return;
  grid.replaceChildren();
  document.querySelector('[data-saved-empty]').hidden = items.length > 0;
  const template = document.querySelector('[data-saved-card-tools]');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.enhanceSavedCard(); observer.unobserve(entry.target); } });
  }, { rootMargin: '400px' }) : null;
  for (const item of items) {
    const card = document.createElement('article'); card.className = 'n-card proto-card';
    const photo = document.createElement('div'); photo.className = 'proto-card__photo';
    const link = document.createElement('a'); link.className = 'n-card__media';
    link.href = root + 'products/' + encodeURIComponent(item.handle); link.dataset.cardLink = '';
    try {
      const url = new URL(item.image, location.origin);
      if (url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com')) {
        const image = document.createElement('img'); url.searchParams.set('width', '720');
        image.src = url.href; image.loading = 'lazy'; image.alt = item.title; image.width = 540; image.height = 720;
        link.append(image);
      }
    } catch {}
    photo.append(link);
    const details = document.createElement('div'); details.className = 'proto-card__details';
    const title = document.createElement('h3'); title.className = 'n-card__name';
    const titleLink = document.createElement('a'); titleLink.href = link.href; titleLink.textContent = item.title;
    title.append(titleLink); details.append(title);
    const tools = template?.content.cloneNode(true);
    const quick = tools?.querySelector('[data-quick-view]');
    if (quick) {
      quick.dataset.productUrl = link.href;
      const labels = JSON.parse(quick.dataset.quickViewCopy);
      quick.setAttribute('aria-label', labels.open + ': ' + item.title);
      photo.append(tools);
    }
    const remove = document.createElement('button'); remove.className = 'n-btn n-btn--tertiary'; remove.textContent = 'Remove';
    remove.addEventListener('click', () => {
      observer?.disconnect();
      localStorage.setItem(key, JSON.stringify(read().filter(saved => saved.handle !== item.handle)));
      refreshSaved();
    });
    card.append(photo, details, remove); grid.append(card);
    card.enhanceSavedCard = async () => {
      try {
        const response = await fetch(link.href + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const product = await response.json();
        if (!card.isConnected) return;
        const labels = quick ? JSON.parse(quick.dataset.quickViewCopy) : {};
        const price = document.createElement('span'); price.className = 'n-card__price';
        const enquiry = !product.price && product.tags.some(tag => /bridal|brides/i.test(tag));
        price.textContent = enquiry ? labels.enquiry : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || quick?.dataset.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(product.price / 100);
        details.append(price);
        if (quick) quick.dataset.enquiry = String(enquiry);
        if (product.type) {
          const category = document.createElement('span'); category.className = 'proto-card__category'; category.textContent = product.type;
          photo.append(category);
        }
      } catch {}
    };
    if (observer) observer.observe(card); else card.enhanceSavedCard();
  }
}

refreshSaved();window.addEventListener('storage',refreshSaved);
document.addEventListener('click',e=>{const b=e.target.closest('[data-save]');if(b){let items=read();items=items.some(i=>i.handle===b.dataset.handle)?items.filter(i=>i.handle!==b.dataset.handle):[...items,{handle:b.dataset.handle,title:b.dataset.title,image:b.dataset.image}];try{localStorage.setItem(key,JSON.stringify(items));refreshSaved()}catch{b.setAttribute('aria-label','Saving is unavailable in this browser')}}const c=e.target.closest('[data-card-color]');if(c){const card=c.closest('.n-card');card.classList.add('color-selected');const img=card.querySelector('.proto-card-primary');if(c.dataset.image){if(c.dataset.imageSrcset){img.sizes=c.dataset.imageSizes;img.srcset=c.dataset.imageSrcset}else{img.removeAttribute('srcset')}img.src=c.dataset.image;img.alt=c.dataset.alt;}card.querySelectorAll('[data-card-link]').forEach(a=>a.href=c.dataset.url);card.querySelectorAll('[data-card-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===c)))}});
document.querySelectorAll('[data-sort]').forEach(select => {
  let committed = new URLSearchParams(location.search).get('sort_by') || 'created-descending';
  select.value = committed;
  let controller, sequence = 0;
  select.addEventListener('change', async () => {
    const section = select.closest('section');
    const owner = select.closest('[id^="shopify-section-"]');
    const grid = section?.querySelector('.n-grid');
    if (!owner || !grid) return;
    const scroll = window.scrollY;
    const copy = JSON.parse(document.querySelector('[data-header-search]')?.dataset.sortCopy || '{}');
    let status = section.querySelector('[data-sort-status]');
    if (!status) { status = document.createElement('p'); status.dataset.sortStatus = ''; status.setAttribute('role','status'); status.style.cssText = 'font-size:14px;min-height:20px;margin:12px 0;color:var(--muted)'; grid.before(status); }
    const requested = select.value;
    const filter = section.querySelector('[data-filter][aria-pressed="true"]')?.dataset.filter || 'all';
    const url = new URL(location.href); url.searchParams.set('sort_by',requested); url.searchParams.delete('page');
    const endpoint = new URL(url); endpoint.searchParams.set('sections',owner.id.replace('shopify-section-',''));
    controller?.abort(); controller = new AbortController(); const requestId = ++sequence;
    grid.setAttribute('aria-busy','true'); grid.style.overflowAnchor = 'none'; status.textContent = copy.loading || '';
    try {
      let html;
      try {
        const response = await fetch(endpoint,{signal:controller.signal,headers:{Accept:'application/json'}});
        if (response.ok) { const sections = await response.json(); html = sections[owner.id.replace('shopify-section-','')]; }
      } catch(error) { if(error.name === 'AbortError') throw error; }
      // Some storefront proxies cannot return dynamic sections. Keep the update
      // in place by reading the equivalent collection HTML in that case.
      if (!html) {
        const response = await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Collection response '+response.status);
        html = await response.text();
      }
      const documentCopy = new DOMParser().parseFromString(html,'text/html');
      const replacementSection = section.id ? documentCopy.getElementById(section.id) : documentCopy.querySelector('section:has(.n-grid)');
      const replacement = replacementSection?.querySelector('.n-grid');
      if (!replacement) throw new Error('Collection grid was absent from the response');
      if (requestId !== sequence) return;
      grid.replaceChildren(...replacement.childNodes);
      section.querySelectorAll('[data-filter]').forEach(button => { if(button.dataset.filter === filter) button.click(); });
      grid.querySelectorAll('[data-color]').forEach(paintSwatch);
      refreshSaved(); document.dispatchEvent(new CustomEvent('naghmana:cards-updated'));
      committed = requested; history.replaceState(history.state,'',url);
      window.scrollTo({top:scroll,behavior:'instant'});
      status.textContent = copy.updated || '';
    } catch(error) {
      if(error.name !== 'AbortError') console.warn('Collection sorting:',error.message);
      if (error.name !== 'AbortError' && requestId === sequence) { select.value = committed; status.textContent = copy.error || ''; }
    } finally { if(requestId === sequence) grid.removeAttribute('aria-busy'); }
  });
});

document.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{const section=b.closest('section');section.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const terms={'2-piece':'2-piece','3-piece':'three-piece','weddings':'luxury','eid':'','embroidered':'embroidered','with trouser':'trouser'};const v=b.dataset.filter;const q=terms[v]??v;let n=0;section.querySelectorAll('.proto-card').forEach(c=>{const only=(c.dataset.filterOnly||'').split('|').filter(Boolean);const excluded=(c.dataset.excludeFilters||'').split('|').filter(Boolean);const tags=c.dataset.filterValues?.split('|');const matches=v==='all'||(section.hasAttribute('data-exact-filters')&&tags?(tags.includes(v)||(v==='silk'&&tags.includes('pure silk'))):c.dataset.filterText.toLowerCase().includes(q));c.hidden=only.length?!only.includes(v):excluded.includes(v)||!matches;if(!c.hidden)n++});let msg=section.querySelector('.proto-empty-filter');if(!msg){msg=document.createElement('p');msg.className='proto-empty-filter';msg.textContent='No pieces match this filter.';section.querySelector('.n-grid').append(msg)}msg.hidden=n>0}));
const product=document.querySelector('[data-product]');if(product){const main=product.querySelector('.proto-product-image');function photo(src,alt,id){if(!src)return;const buttons=[...product.querySelectorAll('[data-gallery-image]')];const chosen=buttons.find(b=>b.dataset.imageId===String(id));if(chosen){main.srcset=chosen.dataset.gallerySrcset;main.sizes=chosen.dataset.gallerySizes;main.src=chosen.dataset.galleryImage}else{main.removeAttribute('srcset');main.src=src}main.alt=alt||'';buttons.forEach(b=>b.setAttribute('aria-current',String(b===chosen)))}product.querySelectorAll('[data-gallery-image]').forEach(b=>b.addEventListener('click',()=>photo(b.dataset.galleryImage,b.dataset.imageAlt,b.dataset.imageId)));const data=product.querySelector('[data-variants]');if(data){const variants=JSON.parse(data.textContent);const form=product.querySelector('form');const add=form.querySelector('[data-add]');const quantity=form.querySelector('[name="quantity"]');function filterGallery() {
  const normalize = value => (value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
  const color = normalize(form.querySelector('[name="options[Color]"]:checked')?.value);
  const colors = [...form.querySelectorAll('[name="options[Color]"]')].map(input => normalize(input.value));
  const buttons = [...product.querySelectorAll('[data-gallery-image]')];
  // Only filter photos with an explicit colour label; descriptive alt text is shared.
  const visibility = buttons.map(button => {
    if (!color || colors.length < 2) return true;
    const labels = (button.dataset.imageAlt || '').split(/[·—]/).map(normalize);
    const imageColor = colors.find(value => labels.includes(value));
    return !imageColor || imageColor === color;
  });
  const hasVisiblePhotos = visibility.some(Boolean);
  buttons.forEach((button, index) => { button.hidden = hasVisiblePhotos && !visibility[index]; });
  const current = buttons.find(button => button.getAttribute('aria-current') === 'true');
  if (current?.hidden) {
    const first = buttons.find(button => !button.hidden);
    if (first) photo(first.dataset.galleryImage, first.dataset.imageAlt, first.dataset.imageId);
  }
}filterGallery();function normalizeMenSuitOptions(){if(product.dataset.productHandle!=='2-piece-blended-suit')return;const fields=[...form.querySelectorAll('[data-option-position]')];const colorInput=form.querySelector('[name="options[Color]"]:checked');const sizeField=fields.find(f=>f.querySelector('[name="options[Size]"]'));if(!colorInput||!sizeField)return;const colorIndex=fields.findIndex(f=>f.contains(colorInput));const sizeIndex=fields.indexOf(sizeField);const matching=variants.filter(v=>v.options[colorIndex]===colorInput.value);const sizes=[...sizeField.querySelectorAll('input')];sizes.forEach(input=>{const exists=matching.some(v=>v.options[sizeIndex]===input.value);input.disabled=!exists;input.closest('label').hidden=!exists});if(!sizes.some(input=>input.checked&&!input.disabled)){const first=matching.find(v=>v.available)||matching[0];const input=sizes.find(input=>input.value===first?.options[sizeIndex]);if(input)input.checked=true}}function pick(){normalizeMenSuitOptions();filterGallery();const options=Array.from(form.querySelectorAll('[data-option-position]')).map(f=>{const value=f.querySelector('input:checked')?.value;f.querySelector('[data-option-label]').textContent='· '+value;return value});const v=variants.find(v=>v.options.every((x,i)=>x===options[i]));form.querySelector('[data-variant-id]').value=v?.id||'';add.disabled=!v?.available;add.textContent=v?.available?'Add to bag':'Sold out';form.querySelector('[data-stock]').textContent=v?.available?'In stock':'This combination is unavailable';if(v){product.querySelector('[data-price]').textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',minimumFractionDigits:0,currency:window.Shopify?.currency?.active||'USD'}).format(v.price/100);const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);if(v.featured_image)photo(v.featured_image.src,v.featured_image.alt,v.featured_image.id)}}form.querySelectorAll('.proto-options input').forEach(i=>i.addEventListener('change',pick));if(product.dataset.productHandle==='2-piece-blended-suit')pick();form.addEventListener('submit',async e=>{e.preventDefault();const status=form.querySelector('[data-product-status]');add.disabled=true;status.textContent='Adding to your bag…';try{const res=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await res.json();if(!res.ok)throw new Error(data.description||'Unable to add this piece.');status.textContent='Added to your bag. ';const a=document.createElement('a');a.href=root+'cart';a.textContent='View bag →';status.append(a);const cartResponse=await fetch(root+'cart.js');if(cartResponse.ok){const cart=await cartResponse.json();document.querySelector('[data-cart-link]')?.setAttribute('aria-label','Cart, '+cart.item_count+' items');const badge=document.querySelector('[data-cart-count]');if(badge){badge.textContent=cart.item_count;badge.style.display=cart.item_count?'block':'none'}}}catch(error){status.textContent=error.message}finally{add.disabled=false}})}}
const subjectValue=new URLSearchParams(location.search).get('subject')||'';
const subject=document.querySelector('[data-contact-subject]');if(subject)subject.value=subjectValue;
if(subjectValue&&location.pathname.endsWith('/pages/contact')){
  let attempts=0;
  const prefill=setInterval(()=>{
    const field=document.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('[id="custom#subject"]');
    if(field){
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(field,subjectValue);
      field.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
      clearInterval(prefill);
    }else if(++attempts>=150)clearInterval(prefill);
  },100);
}
})();

